import React, {useState} from 'react';
//import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar';
import './MyCalendar.css';
import s from './MyCalendar.module.css';

export type ValuePiece = Date | null;
export type Value = ValuePiece | [ValuePiece, ValuePiece];
type Props = {
	setFieldValue: any;
	fieldName: string;
	onDateSelected?: () => void;
};
const MyCalendar: React.FC<Props> = ({setFieldValue, fieldName, onDateSelected}) => {
	const [value, onChangeValue] = useState<Value>(new Date());

	const handleChange = (newValue: any) => {
		const dateObject = new Date(newValue);
		const year = dateObject.getFullYear();
		const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
		const day = dateObject.getDate().toString().padStart(2, '0');
		setFieldValue(fieldName, `${year}-${month}-${day}`);
		onChangeValue(newValue);
		onDateSelected?.();
	};

	return (
		<Calendar
			tileClassName={s.calendarTile}
			className={s.calendarContainer}
			onChange={handleChange}
			value={value}
		/>
	);
};

export default MyCalendar;
